/** True when a non-negative finite discount has at most two decimal places. */
export function hasDiscountPercentPrecision(value: number): boolean {
  if (!Number.isFinite(value) || value < 0) return false;
  const scaled = value * 100;
  return (
    Number.isSafeInteger(Math.round(scaled)) &&
    Math.abs(scaled - Math.round(scaled)) < 1e-8
  );
}
